export default "__VITE_ASSET__DOuf9Ml4__"